module.exports = __webpack_public_path__ + "img/logo.3714459d.jpg";